import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-10" className="point" id="0-10">第十一章 采购管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>
        <h2 name="0-10-0" className="point" id="0-10-0">一、集团公司集中采购管理制度</h2>
        <h3 name="0-10-0-0" className="point" id="0-10-0-0">1、总则</h3>
        <p>1.1 目的 为规范云豪集团采购行为, 加强对采购活动的管理与监督,节约采购成本支出，降低经营成本，特制定本制度. </p>
        <p>1.2 适用范围 本制度适用于云豪集团各业务管理公司。</p>
        <p>1.3 物资采购分类：通用物资采购及专用物资采购。</p>
        <p>1.4 通用物资定义：适用于各业务管理公司使用的物资，例如：车间维修工具、劳保用品、滤芯、油品、轮胎等；专用物资定义：仅能用于该业务管理公司的使用的物资，例如：消防设备等。</p>
        <h3 name="0-10-0-1" className="point" id="0-10-0-1">2、集中采购流程</h3>
        <p>2.1 需求提报：</p>
        <p>2.1.1
            年度价格协议：各业务管理公司根据下一年的年度计划及往年的购销数量做出下一年度的年度采购计划。由各管理公司采购部需在上年度11月下旬提报下年度采购计划，集采中心根据各业务管理公司提交的需求确定采购物资的供方，与供方签订价格协议。</p>
        <p>2.1.2 各管理公司在协议价格确定后，在后续的采购中价格不得高于此协议价。</p>
        <p>2.1.3 由各业务管理公司的需求部门将采购需求提报至本公司的采购部。</p>
        <p>2.1.4 国内采购: A、B类需在到货日前提前3个工作日提出需求 ；C、D类需在到货日前提前5个工作日提出需求； E类需在到货日前提前2周提出需求。A/B/C/D/E分类参照《通用物资集中采购目录》。国外采购：
            需在到货日期前提前3周并加预估海运时间提出需求。</p>
        <p>2.1.5 采购部判定采购需求是否属于《通用物资集中采购目录》的范围，如是则整理需求并填写《集中采购申请审批表》中的需求单位-采购需求说明部分，并提交审批表至事业部负责人进行审核。如不是则进入专用物资采购流程。</p>
        <p>2.1.6 采购部在确定采购数量时，必须先确定本公司及其他业务管理公司是否有同类产品的库存。</p>
        <p>2.1.7 事业部负责人审批通过后交给集采中心。</p>
        <p>2.2 供方资源落实：</p>
        <p>2.2.1 集采中心采购员对采购需求计划进行确认，并确定采购方式。</p>
        <p>2.2.2 采购员落实供应商资源后，对报价信息整理并填写《集中采购申请审批表》中的 集采中心-供方明细部分，并提交至集采中心负责人审核。</p>
        <p>2.2.3 集采中心负责人确定供方，并提交至集团财务部进行审批。</p>
        <p>2.3 采购审批：</p>
        <p>2.3.1 由集团财务部根据审批表中的内容，确定此次采购是否进行。</p>
        <p>2.3.2 如通过，集采中心通知各业务管理公司采购部合格的供方名单。</p>
        <p>2.3.2 不通过，集采中心根据财务部的意见进行调整。</p>
        <p>2.4 合同签订及付款申请：</p>
        <p>2.4.1 由各业务管理公司采购部与供方签订采购合同。</p>
        <p>2.4.2 由各业务管理公司采购部向集团公司财务部进行付款申请。</p>
        <p>2.5 付款：</p>
        <p>2.5.1 由集团财务部根据合同付款条件进行付款。</p>
        <p>2.6 发货：</p>
        <p>2.6.1 供方根据合同的交货日期进行交付。</p>
        <p>2.6.2 各业务管理公司采购部跟进到货进展。 </p>
        <p>2.7 到货：</p>
        <p>2.7.1 由各业务管理公司仓储部门对货物进行清点，合格则入库；不合格则及时反馈差异至本公司的采购部；</p>
        <p>2.7.2 由本公司的采购部人员与供方确认差异问题，并进行退换货处理。</p>
        <h3 name="0-10-0-2" className="point" id="0-10-0-2">3、部门职责</h3>
        <p>3.1 集采中心：</p>
        <p>3.1.1 通用物资集中采购。</p>
        <p>3.1.2 建立及更新通用物资供应商档案，为集团经常性采购的物资优选2~3家相对固定的供应商。</p>
        <p>3.1.3 建立及完善《通用物资集中采购目录》。</p>
        <p>3.1.4 建立及完善集中采购流程。</p>
        <p>3.1.5 建立采购档案，定期分析和汇报各项采购工作。</p>
        <p>3.1.6 监督各业务管理公司物资采购的执行情况。</p>
        <p>3.2 各业务管理公司采购部：</p>
        <p>3.2.1 专用物资的采购。</p>
        <p>3.2.2 提报通用物资采购需求。</p>
        <p>3.2.3 建立本公司的专用物资采购的供应商档案。</p>
        <p>3.2.4 对采购合同进行管理、申请付款、跟进到货进展、确认到货差异。</p>
        <p>3.2.5 参与通用物资采购供应商明细推荐。</p>
        <p>3.3 各业务管理公司仓储部：</p>
        <p>3.3.1 到货检验，及时反馈到货差异给各管理公司采购部。</p>
        <p>3.3.2 办理入库，负责清点登记入账与库存物资的保管。</p>
        <p>3.4 集团财务部：</p>
        <p>3.4.1 审批集中采购需求</p>
        <p>3.4.3 参与采购流程的制定</p>
        <h3 name="0-10-0-3" className="point" id="0-10-0-3">4、采购方式</h3>
        <p>4.1 采购方式分类：</p>
        <p>询价采购及招标采购。</p>
        <p>4.2 询价采购定义：</p>
        <p>指对3家及其以上符合要求的供应商，对其提供的报价及服务进行比较，从而选出更有竞争优势的供方；</p>
        <p>4.3 招标采购定义： </p>
        <p>分为公开招标及邀请招标。公开招标是指通过招标公告的方式邀请不特定的法人或者其他组织投标的采购方式；邀请招标通过投标邀请书邀请3家以上（含3家）达到规定资质的供应商投标的采购方式. </p>
        <p>4.4 询价采购适用范围：</p>
        <p>于采购金额少，规格标准明确，价格透明度高，供方资源丰富。
        </p>
        <p>4.5 招标采购适用范围：</p>
        <p>采购频次多，数量多，金额大的情况。</p>
        <h3 name="0-10-0-4" className="point" id="0-10-0-4">5、通用物资集中采购目录</h3>
        <p>5.1 通用物资集中采购目录制定标准：</p>
        <p>根据各管理公司采购物资种类，数量，频次，金额所决定。</p>
        <p>5.2 通用物资集中采购目录更新频率：</p>
        <p>集采中心每周跟进各管理公司的专用物资采购需求，确定采购频次高，数量多的同种类产品，每个月形成采购备选目录，持续跟进备选目录的三个月或半年采购情况，于每个季度或半年向集团发布一次更新采购目录。</p>
        <p>5.3 《通用物资集中采购目录》</p>

        <h3 name="0-10-0-5" className="point" id="0-10-0-5">6、专用物资的采购流程</h3>
        <p>6.1 需求提报：</p>
        <p>6.1.1 年度价格协议：各业务管理公司长期采购的专用物资也需签署年度价格协议。长期采购的专用物资是指每年都有特定量采购的物资。</p>
        <p>6.1.2
            由各管理公司的采购部于上一年度11月下旬提出下一年长期采购的专用物资年度采购计划。集采中心根据各业务管理公司提交的需求确定采购物资的供方，与供方签订价格协议。各管理公司在协议价格确定后，在后续的采购中价格不得高于此协议价。</p>
        <p>6.1.3 由各业务管理公司的需求部门将采购需求提报至本公司的采购部。</p>
        <p>6.1.4 国内采购: A、B类需在到货日前提前3个工作日提出需求 ；C、D类需在到货日前提前5个工作日提出需求；
            E类需在到货日前提前2周提出需求。A/B/C/D/E分类参照《通用物资集中采购目录》。国外采购：
            需在到货日期前提前3周并加预估海运时间提出需求。</p>
        <p>6.1.5 采购部整理需求并填写《专用物资采购申请审批表》中的采购需求说明部分，并提交审批表至事业部负责人进行审核。</p>
        <p>6.1.6 采购部在确定采购数量时，必须先确定本公司及其他业务管理公司是否有同类产品的库存，如有，采购数量需减去库存量。</p>
        <p>6.1.7 事业部负责人审批通过后交给采购部。</p>
        <p>6.2 供方资源落实：</p>
        <p>6.2.1 各业务管理公司采购部确定采购方式。</p>
        <p>6.2.2 采购员落实供应商资源后，对报价信息整理并填写《集中采购申请审批表》中的供方明细，并提交至采购部负责人进行审核。</p>
        <p>6.2.3 采购部负责人确定供方，并提交至集采中心进行审批。</p>
        <p>6.3 采购审批：</p>
        <p>6.3.1 集采中心对提交的审批表进行审核，如符合要求，提交给集团财务部进行审核；如不符合要求，返回至各业务管理公司采购部进行修改。</p>
        <p>6.3.2 集团财务部对集采中心提交的审批表进行审批，如通过，集采中心通知各管理公司采购部进行采购。如不通过，集采中心根据集团财务部的意见要求各管理公司财务部进行整改。</p>
        <p>6.4 合同签订及付款申请：</p>
        <p>6.4.1 由各业务管理公司采购部与供方签订采购合同。</p>
        <p>6.4.2 由各业务管理公司采购部向集团公司财务部进行付款申请。</p>
        <p>6.5 付款：</p>
        <p>6.5.1 由集团财务部根据合同付款条件进行付款。</p>
        <p>6.6 发货：</p>
        <p>6.6.1 供方根据合同的交货日期进行交付。</p>
        <p>6.6.2 各业务管理公司采购部跟进到货进展。 </p>
        <p>6.7 到货：</p>
        <p>6.7.1 由各业务管理公司仓储部门对货物进行清点，合格则入库；不合格则及时反馈差异至本公司的采购部；</p>
        <p>6.7.2 由本公司的采购部人员与供方确认差异问题，并进行退换货处理。</p>
        <h3 name="0-10-0-6" className="point" id="0-10-0-6">7、采购物资库存控制</h3>
        <p>7.1 库存盘点</p>
        <p>仓库保管人员每月末对本公司库存物资进行一次盘点，将盘点结果及时上报主管部门，并请其对盘点中产生的盘亏、盘盈进行及时处理，得到批示后对盘点结果进行处理、调整账面存量。</p>
        <p>7.2 设定安全库存量</p>
        <p>采购人员应当确定物资的安全库存量，并促使仓库存货在安全库存量以上，以减少缺货情况，降低缺货成本。</p>
        <p>7.3 库存分类控制</p>
        <p>为了合理控制库存量，将物资按照战略重要程度分为A、B、C三类，每类物资的划分标准及库存管理方法如下表所示。</p>

        <p>7.4 及时处理呆废料，提高可用库存占库存总量的比例</p>
        <p>仓库保管人员每月上报公司领导呆料、废料明细表，经公司领导批示后及时处理，做到物尽其用、减少资金积压、节省人力、节约仓储空间。</p>
        <h3 name="0-10-0-7" className="point" id="0-10-0-7">8、附则</h3>
        <p>1、本制度由集采中心负责解释与修订</p>
        <p>本制度自发布之日起执行</p>

        <p>附件1 </p>
        <p>《集中采购流程》</p>
        <p>附件1-1</p>
        <p>《集中采购申请审批表》</p>
        <p>附件2</p>
        <p>《专用物资采购流程》</p>
        <p>附件2-1</p>
        <p>《专用件物资申请审批表》</p>
        <p>附加3</p>
        <p>《通用物资集中采购目录》</p>
        <p>附件4</p>
        <p>《集中采购流程图》</p>


        <h2 name="0-10-1" className="point" id="0-10-1">二、生活物资采购流程</h2>
        <p>一、目的：为规范我司生活物资采购流程，降低公司采购成本，特制订本制度。</p>
        <p>二、适用范围</p>
        <p>1、办公用品：办公</p>桌、办公椅、文件柜、电脑、空调、饮水机等办公设备以及纸、笔、票据等日常办公消耗用品。
        <p>2、劳保用品：安全帽、安全鞋、口罩、眼面护具、防护服、手套等。</p>
        <p>3、后勤用品：炊具、灶具、洗浴具等。</p>
        <p>三、内容</p>
        <p>1、采购程序及询价</p>
        <p>1.1、各部门根据业务、使用情况提出采购申请；由本部门的采购接口人填写《物资采购申请单》，列出采购物品明细，包括名称、数量、单品价格、推荐采购厂家供采购员参考用。</p>
        <p>1.2、为确保采购周期，各部门采购接口人应提前将采购需求告知采购员。</p>
        <p>1.3、为节约采购成本，采购员应向至少2家以上的厂家发出询价要求，在综合价格、质量、服务的方面后优先选择物美价廉的物品。</p>
        <p>2、采购审批</p>
        <p>2.1、单笔采购金额小于500元，由各部门采购接口人提出申请，各事业部总经理审批后，由指定的采购员进行采购。</p>
        <p>2.2、单笔采购金额大于500元，由各部门采购接口人提出申请，各事业部总经理审批后，还需行政副总裁签批后，才能由指定的采购员进行采购。</p>
        <p>3、采购验收</p>
        <p>采购回来的物品，由各部门采购员负责验收跟进，确认实物名称、型号、数量等是否与《物资采购申请单》相一致并记录验收结果。如有差异及时与供应商联系。</p>
        <p>4、采购付款</p>
        <p>采购物品的付款，由各部门采购员负责向财务部提出付款申请，并向财务部提供相关的采购凭证（专用发票等）。</p>
        <p>5、采购物品变更</p>
        <p>5.1、请购部门的采购计划发生变更后，应重新填写《物资采购申请单》，按照采购流程执行。</p>
        <p>5.2、如因采购物品发生缺货，采购员应及时通知请购部门，经协商后更改采购内容，然后重新填写《物资采购申请单》，按照采购流程执行。</p>
        <p>6、其他相关规定</p>
        <p>6.1、 采购员在未取得各事业部总经理或行政副总裁的批准的情况下，擅自采购物品的，财务部在没有得到相关领导的明确指示前将不予付款。同时，公司将按规定对采购员进行处罚。</p>
        <p>6.2、采购物资的采购期限按照自接到通过批准的《物资采购申请单》开始，通常3个工作日内完成采购。未完成的，需向相关领导进行汇报说明原因。</p>
        <p>6.3、本制度将</p>随企业的发展及实际情况适时进行更新及修订，更新后的内容将自动成为受制约者的行为准则。
        <h2 name="0-10-2" className="point" id="0-10-2">三、生产物资采购流程</h2>
        <p>一、目的：为规范我司生产物资采购流程，降低公司采购成本，特制订本制度。</p>
        <p>二、适用范围</p>
        <p>1、生产设备及材料：起重机、货架、基础建设所用设备及材料等。</p>
        <p>2、生产工具：工作台、修理工具、诊断仪等。</p>
        <p>3、车辆：救援车、叉车等。</p>
        <p>三、内容</p>
        <p>1、 采购程序及询价</p>
        <p>1.1、各部门根据业务、使用情况提出采购申请；由本部门的采购接口人填写《物资采购申请单》，列出采购物品明细，包括名称、数量、单品价格、推荐采购厂家供采购员参考用。</p>
        <p>1.2、为确保采购周期，各部门采购接口人应提前将采购需求告知采购员。</p>
        <p>1.3、为节约采购成本，采购员应向至少2家以上的厂家发出询价要求，在综合价格、质量、服务的方面后优先选择物美价廉的物品。</p>
        <p>2、采购审批</p>
        <p>2.1、单笔采购金额小于500元，由各部门采购接口人提出申请，各事业部总经理审批后，由指定的采购员进行采购。</p>
        <p>2.2、单笔采购金额大于500元，由各部门采购接口人提出申请，各事业部总经理审批后，还需经技术应用管理中心负责人签批后，才能由指定的采购员进行采购。</p>
        <p>3、采购验收</p>
        <p>采购回来的物品，由各部门采购员负责验收跟进，确认实物名称、型号、数量等是否与《物资采购申请单》相一致并记录验收结果。如有差异及时与供应商联系。如需要入库的，及时协助库管进行点收。</p>
        <p>4、采购付款</p>
        <p>采购物品的付款，由各部门采购员负责向财务部提出付款申请，并向财务部提供相关的采购凭证（发票及入库/出库单号）</p>
        <p>5、采购物品变更</p>
        <p>5.1、请购部门的采购计划发生变更后，应重新填写《物资采购申请单》，按照采购流程执行。</p>
        <p>5.2、如因采购物品发生缺货，采购员应及时通知请购部门，经协商后更改采购内容，然后重新填写《物资采购申请单》，按照采购流程执行。</p>
        <p>6、其他相关规定</p>
        <p>6.1、采购员在未取得各事业部总经理或行政副总裁的批准的情况下，擅自采购物品的，财务部在没有得到相关领导的明确指示前将不予付款。同时，公司将按规定对采购员进行处罚。</p>
        <p>6.2、采购物资的采购期限按照自接到通过批准的《物资采购申请单》开始，通常20个工作日内完成采购。未完成的，需向相关领导进行汇报说明原因。</p>
        <p>6.3、本制度将随企业的发展及实际情况适时进行更新及修订，更新后的内容将自动成为受制约者的行为准则。</p>
        <h2 name="0-10-3" className="point" id="0-10-3">四、供应商管理细则</h2>
        <p>一、生产物资供应商</p>
        <p>1、供应商选择</p>
        <p>1.1、供应商为生产型企业：应具备生产经营所需的合法证件。</p>
        <p>生产质量体系需取得TS16949相应证书。</p>
        <p>应综合考虑供应商的供货能力，价格控制，质量控制，物流管理，售后服务等各方面的水平进行评估。</p>
        <p>根据产品的特性确定是否去供应商的生产现场进行审核。</p>
        <p>1.2、供应商为中间商：</p>
        <p>应具备生产经营所需的合法证件。</p>
        <p>应考虑其企业资信、技术服务能力、价格和以往的服务对象。</p>
        <p>应至少选择2家以上供应商进入备选行列。</p>
        <p>2、供应商送样</p>
        <p>在确定好供应商后：</p>
        <p>根据产品的特性采购若干样件进行试装以验证产品的装配性。</p>
        <p>另可根据产品特性进行路试验证产品的功能和可靠性。</p>
        <p>供应商应提供产品的试验报告和出厂检验报告。</p>
        <p>3、供应日常考核</p>
        <p>问题发生率：入库和售后问题发生的频次；</p>
        <p>送货满足率：送货数量和产品差异的频次；</p>
        <p>顾客满意度：对我方提出的问题和要求是否能够及时处理；</p>
        <p>4、变更管理</p>
        <p>厂家发生的任何变更(产品或其他)应及时通知并征得我方同意，根据变更内容，确定是否需要重新采样进行产品验证。</p>
        <p>二、生活物资供应商</p>
        <p>1、优选原则之前合作过的厂家。</p>
        <p>2、对于单次采购>5000元以上，必有三家以上供应商提供报价，在权衡质量、价格、交货时间、售后、企业资信综合评估，并与供应商进一步议定最终价格，临时性应急购买的物品除外。</p>

        <h2 name="0-10-4" className="point" id="0-10-4">五、采购计划表范本</h2>


    </div>
</div>;

export default Section$;
